import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { PlantFormProps } from "./PlantFormProps";
import { TextFieldInput } from "../../Forms/TextFieldInput";
import Plant, { isExistingPlant } from "../Plant";
import { UPPERCASE_INPUT } from "../../Forms/formStyles";
import { BorderedFormGrid } from "../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../Forms/MdmFormProps";

export const PlantGsdbForm = ({ plant, disabledFields }: PlantFormProps & MdmFormProps) => {
  const { control } = useFormContext<Plant>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput
          name="Gsdb"
          control={control}
          label="GSDB"
          required
          disabled={isExistingPlant(plant)}
          inputProps={UPPERCASE_INPUT}
        />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput
          name="TwoDigitCode"
          control={control}
          label="Two Digit Code"
          disabledFields={disabledFields}
          inputProps={UPPERCASE_INPUT}
        />
      </Grid>

      {/* Placeholder */}
      <Grid item xs={6} />
    </BorderedFormGrid>
  );
};
